import * as Sentry from "@sentry/nextjs";

const localLogger = {
  debug: "debug",
  info: "info",
  warning: "warn",
  error: "error",
  fatal: "error",
  log: "log",
} as const;

export const logWithNotification = (
  message: string,
  level: Sentry.SeverityLevel = "warning",
  extra?: Record<string, any>,
) => {
  const consoleMethod = console[localLogger[level]];
  consoleMethod?.(message);

  Sentry.captureMessage(message, {
    level,
    tags: { should_notify: true },
    ...(extra && { extra }),
  });
};
